module.exports = __webpack_public_path__ + "assets/img/eicon.6201ff0c.svg";